/**
 * Console guard.
 * - dev | qa: logs on by default.
 * - Other envs: no logs unless sessionStorage "ENABLE_CONSOLE_LOGS" is set, and only on localhost.
 */

const CONSOLE_FLAG_KEY = 'ENABLE_CONSOLE_LOGS';

function isDevOrQa() {
  const env = process.env.REACT_APP_ENV?.toLowerCase?.();
  return env === 'dev' || env === 'qa';
}

function isLocalhost() {
  if (!globalThis.window?.location?.hostname) {
    return false;
  }
  const hostname = globalThis.window.location.hostname.toLowerCase();
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}

function hasSessionFlag() {
  try {
    return Boolean(globalThis.sessionStorage?.getItem(CONSOLE_FLAG_KEY));
  } catch {
    return false;
  }
}

function isConsoleEnabled() {
  if (isDevOrQa()) {
    return true;
  }
  return isLocalhost() || hasSessionFlag();
}

const noop = () => {};

/**
 * Call once at app bootstrap. When not dev/qa, console.log/debug/info are no-ops unless ENABLE_CONSOLE_LOGS is set (and on localhost).
 */
export function applyConsoleGuard() {
  if (isConsoleEnabled()) {
    return;
  }
  const methods = ['log', 'debug', 'info'];
  methods.forEach((method) => {
    if (typeof console[method] === 'function') {
      console[method] = noop;
    }
  });
}

export { CONSOLE_FLAG_KEY, isConsoleEnabled };
